import Analytics from '../../../../../../../../analytics';

export const faOnPackageScroll = ({ sectionCode, currentRow }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.PRODUCT_VIEWED,
    event_value: `${sectionCode ? `${sectionCode}|` : ''}${currentRow}`,
  });
};
